<template>
    <div>
        <div class="form-group">
            <label>Endpoint</label>
            <input type="text" class="form-control" v-model="data.endpoint">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
